import React from "react";
import "./Hero.css";
import { SiMysql } from "react-icons/si";
import { FaHtml5 } from "react-icons/fa";
import { FaLaravel } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import CV from '../../assets/cv.pdf'
const Hero = () => {
  return (
    <section className="hero-container">
      <div className="hero-content">
        <h2>Hello I'am <br/><span className="name">SOMALI Nathanaël  Edudzi</span></h2>
        <h1 className="full-stack">Fullstack Developper</h1><br/>
        <p>I am passionate about technology and programming, aiming to put my skills into practice to create innovative and functional solutions.</p>
        <div className="social">

            
        </div>
        <div className="buttons">
            <a href={CV} download className="btn">Download CV</a>
            <a href="#contact" className="btn">Contact Me </a>
            <a href="#skills-container" className="btn">Learn More</a>
            </div>     
      </div>
      
      <div className="hero-img">
        <div>
          <div className="tech-icon">
          <FaHtml5 />
          </div>

          <img className="img" src="./assets/images/img11.png" alt="" width={400} />
        </div>
        <div>
          <div className="tech-icon">
          <FaReact />
          </div>
          <div className="tech-icon">
          <FaLaravel />
          </div>
          <div className="tech-icon">
          <SiMysql />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
